import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KpiService {
  private kpiData = new BehaviorSubject<any[]>([]);
  kpiData$ = this.kpiData.asObservable();

  constructor() {}

  saveKpiData(data: any) {
    const currentData = this.kpiData.getValue();
    const updatedData = [...currentData, data];
    this.kpiData.next(updatedData);
    console.log(this.kpiData, 'kpi Service');
  }

  getKpiData() {
    return this.kpiData.getValue();
  }
}